module.exports = __webpack_public_path__ + "img/b-1.f1d787ac.jpg";